/* eslint-disable import/prefer-default-export */
import { globalDataApi } from '../globalDataApi';

export const { useGetProductsQuery } = globalDataApi.injectEndpoints({
  endpoints: b => ({
    getProducts: b.query({
      keepUnusedDataFor: 0,
      // 0-based pagination from MUI DataGrid
      query: ({ page = 0, pageSize = 100, ...filters } = {}) => ({
        // send 1-based pagination to backend
        params: { page: page + 1, pageSize, ...filters },
        url: 'get-products',
      }),
    }),
  }),
});
